<template>
    <app-dialog v-if="pwdDialogShow"
                customClass="pwdDialog"
                :title="title"
                @onCancel="pwdDialogCancel"
                @onSubmit="pwdDialogSubmit">
        <el-form :model="passwordForm" class="dialog-form" :rules="rules" ref="passwordForm">
            <el-form-item label="原密码：" prop="oldPassword">
                <el-input class="input-height" show-password
                          @keyup.enter.native="pwdDialogSubmit"
                          type="password" v-model="passwordForm.oldPassword" placeholder="请输入原密码" />
            </el-form-item>
            <el-form-item label="新密码：" prop="password">
                <el-input class="input-height" show-password
                          @keyup.enter.native="pwdDialogSubmit"
                          type="password" v-model="passwordForm.password" placeholder="请输入新密码" />
            </el-form-item>
            <el-form-item label="确认密码：" prop="confirmPassword">
                <el-input class="input-height" show-password type="password"
                          v-model="passwordForm.confirmPassword"
                          @keyup.enter.native="pwdDialogSubmit"
                          placeholder="请再次输入新密码" />
            </el-form-item>
        </el-form>
    </app-dialog>
</template>
<script>
import AppDialog from '../../components/ui/AppDialog';
import { accountApi } from '../../../apiAxios/modules/account.api';
import { formatResetPwdParams } from '../../../utils/ssoLogin';
export default {
    name: 'change-password',
    components: {
        AppDialog
    },
    data () {
        return {
            title: '',
            pwdDialogShow: false,
            passwordForm: {
                oldPassword: '',
                username: '',
                password: '',
                confirmPassword: ''
            },
            rules: {
                oldPassword: [
                    { required: true, message: '原密码不能为空' }
                ],
                password: [
                    { required: true, validator: this.validatePass, trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, validator: this.validatePass2, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        showDialog (userCode, restType = 2) {
            // 重置密码类型 首次登陆：1 || 修改密码：2
            this.userCode = userCode;
            this.restType = restType;
            if (+restType === 1) {
                this.title = '首次登陆重置密码';
            } else {
                this.title = '修改密码';
            }
            this.pwdDialogShow = true;
        },
        pwdDialogCancel () {
            this.passwordForm = {
                oldPassword: '',
                username: '',
                password: '',
                confirmPassword: ''
            };
            this.pwdDialogShow = false;
        },
        validatePass  (rule, value, callback) {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[()])+$)([^(0-9a-zA-Z)]|[()]|[a-z]|[A-Z]|[0-9]){8,16}$/.test(value)) {
                    if (value === this.passwordForm.oldPassword) {
                        callback(new Error('新密码不能和原密码一样！'));
                    } else if (this.passwordForm.confirmPassword !== '') {
                        this.$refs.passwordForm.validateField('confirmPassword');
                    }
                } else {
                    callback(new Error('密码需含字母/数字/符号至少2种,且长度为8-16'));
                }

                callback();
            }
        },
        validatePass2  (rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.passwordForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        },
        pwdDialogSubmit () {
            this.$refs['passwordForm'].validate((valid) => {
                if (valid) {
                    accountApi.ssoResetPwd(formatResetPwdParams(this.passwordForm.oldPassword, this.passwordForm.password, this.userCode)).then((resp) => {
                        if (resp.StatusCode === 200) {
                            if (resp.OpCode === 0) {
                                this.$alert('密码修改成功，请重新登录', '修改成功', {
                                    confirmButtonText: '确定',
                                    callback: action => {
                                        this.$store.commit('account/logout');
                                    }
                                });
                            } else {
                                this.$message(resp.OpDesc);
                            }
                        }
                    });
                } else {
                    this.$message.error('请输入密码');
                }
            });
        }
    }
};
</script>
<style lang="scss">
.pwdDialog {
    .el-form-item {
        .el-form-item__label {
            width: 100px;
        }
    }
}
</style>
